import { createSlice } from '@reduxjs/toolkit';

import { IAdminsState } from './interfaces';
import { loadAdminsItem, loadAdminsList } from './actions';

export const adminsSlice = createSlice({
  name: 'admins',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
  } as IAdminsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadAdminsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadAdminsItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
